<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="card" *ngIf="UserModuleAccess=='Full'">
	<div class="card-header bg-theme">
		{{pagetitle}}
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="saveAppt()" #modform="ngForm">
			<div class="row g-1 mb-2">
				<!-- <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="companyList" bindLabel="comp_name" bindValue="apptid"
						[clearable]="true" [multiple]="false" id="main_company" formControlName="main_company"
						placeholder="Company*" [appearance]="'outline'"
						[ngClass]="{'is-invalid':showError1('main_company')}">
					</ng-select>
					<p *ngIf="showError1('main_company')" class="text-danger">
						<span *ngIf="f.main_company.errors?.required">
							Required
						</span>
					</p>
				</div> -->
				<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="companyList" bindLabel="comp_name" bindValue="apptid"
						[clearable]="true" [multiple]="false" id="company" formControlName="company"
						placeholder="Company*" [appearance]="'outline'"
						[ngClass]="{'is-invalid':showError1('company')}">
					</ng-select>
					<p *ngIf="showError1('company')" class="text-danger">
						<span *ngIf="f.company.errors?.required">
							Required
						</span>
					</p>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="profileList" bindLabel="name" bindValue="id" [clearable]="true"
						[multiple]="false" id="profile" formControlName="profile" placeholder="Profile*"
						[appearance]="'outline'" [ngClass]="{'is-invalid':showError1('profile')}">
					</ng-select>
					<p *ngIf="showError1('profile')" class="text-danger">
						<span *ngIf="f.profile.errors?.required">
							Required
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<mat-form-field appearance="outline">
						<mat-label>DOE</mat-label>
						<input matInput [matDatepicker]="doe_picker_template" formControlName="DOE">
						<mat-datepicker-toggle matIconSuffix [for]="doe_picker_template"></mat-datepicker-toggle>
						<mat-datepicker #doe_picker_template></mat-datepicker>
					</mat-form-field>
					<p *ngIf="showError1('DOE')" class="text-danger">
						<span *ngIf="f['DOE'].errors?.required">
							Required
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError1('numberOfCandidate')}"
							id="numberOfCandidate" formControlName="numberOfCandidate" placeholder="">
						<label for="numberOfCandidate">
							No. of Candidates*
						</label>
					</div>
					<p *ngIf="showError1('numberOfCandidate')" class="text-danger">
						<span *ngIf="f['numberOfCandidate'].errors?.required">
							Required
						</span>
						<span *ngIf="f['numberOfCandidate'].errors?.pattern">
							Invalid
						</span>
					</p>
				</div>
			</div>
			<div class="row g-1 mb-2">
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError1('numberOfTrainers')}"
							id="numberOfTrainers" formControlName="numberOfTrainers" placeholder="">
						<label for="numberOfTrainers">
							No. of Trainers
						</label>
					</div>
					<p *ngIf="showError1('numberOfTrainers')" class="text-danger">
						<span *ngIf="f['numberOfTrainers'].errors?.required">
							Required
						</span>
						<span *ngIf="f['numberOfTrainers'].errors?.pattern">
							Invalid
						</span>
					</p>
				</div>
			</div>
			<div formArrayName="appointments" *ngFor="let creds of get_appointments.controls; let i = index">
				<ng-container [formGroupName]="i">
					<div class="card mb-2">
						<div class="card-header bg-secondary">
							@if(creds.get('id')?.value){
							<mat-checkbox color="primary" formControlName="selected" class="in-header">
								Candidate-{{i+1}}
							</mat-checkbox>
							}@else {
							<span class="fs-14">
								Candidate-{{i+1}}
							</span>
							}
							<button type="button" (click)="deleteAppt(i)" class="btn btn-xs btn-danger float-end">
								Delete
							</button>
							<!-- @if(creds.get('id')?.value){
							<a class="btn btn-xs btn-info float-end me-1"
								[routerLink]="['/app/userscore',creds.get('id')?.value]">
								<fa-icon [icon]="['fas', 'file']">
								</fa-icon>
								Report
							</a>
							} -->
							<!-- <button type="button" (click)="createCertificate(i)"
								class="btn btn-sm btn-info float-end me-2" *ngIf="creds.get('id')?.value"
								matTooltip="Certificate">
								<fa-icon *ngIf="pdfDownloadLoader != creds.get('id')?.value"
									[icon]="['fas', 'cloud-download-alt']"></fa-icon>
								<fa-icon *ngIf="pdfDownloadLoader == creds.get('id')?.value" [icon]="['fas', 'spinner']"
									[animation]="'spin'"></fa-icon>
							</button>
							<input *ngIf="creds.get('id')?.value" type="checkbox" name="switch"
								class="custom-checkbox float-end me-2 mt-1" formControlName="attend"
								(change)="changeAttend(i)" matTooltip="Attended"> -->
						</div>
						<div class="card-body">
							<div class="row g-1 mb-2">
								<!-- <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'f_name')}"
											formControlName="f_name" placeholder="First Name*">
										<label for="f_name">First Name*</label>
									</div>
									<p *ngIf="showError2(i,'f_name')" class="text-danger">
										<span *ngIf="creds.get('f_name')?.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'l_name')}"
											formControlName="l_name" placeholder="Last Name*">
										<label for="l_name">Last Name*</label>
									</div>
									<p *ngIf="showError2(i,'l_name')" class="text-danger">
										<span *ngIf="creds.get('l_name')?.errors?.required">
											Required
										</span>
									</p>
								</div> -->
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'name')}"
											formControlName="name" placeholder="">
										<label for="name">Name*</label>
									</div>
									<p *ngIf="showError2(i,'name')" class="text-danger">
										<span *ngIf="creds.get('name')?.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<ng-select appendTo="body" [items]="rankList" bindLabel="rank" bindValue="id"
										[clearable]="true" [multiple]="false" formControlName="rank" placeholder="Rank*"
										[appearance]="'outline'" [ngClass]="{'is-invalid':showError2(i,'rank')}">
									</ng-select>
									<p *ngIf="showError2(i,'rank')" class="text-danger">
										<span *ngIf="creds.get('rank')?.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
									<label>Gender*:</label>
									<br />
									<mat-radio-group aria-label="Select an option" formControlName="gender">
										<mat-radio-button [name]="'gender'" ngDefaultControl [value]="'Male'"
											[color]="'primary'">
											Male
										</mat-radio-button>
										<mat-radio-button [name]="'gender'" ngDefaultControl [value]="'Female'"
											[color]="'primary'">
											Female
										</mat-radio-button>
									</mat-radio-group>
									<p *ngIf="showError2(i,'gender')" class="text-danger">
										<span *ngIf="creds.get('gender')?.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'email')}"
											formControlName="email" placeholder="Email">
										<label for="email">Email</label>
									</div>
									<p *ngIf="showError2(i,'email')" class="text-danger">
										<span *ngIf="creds.get('email')?.errors?.required">
											Required
										</span>
										<span *ngIf="creds.get('email')?.errors?.email">
											Invalid
										</span>
									</p>
								</div>
							</div>
							<!-- <div class="row g-1 mb-2">
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<ng-select appendTo="body" [items]="companyList" bindLabel="comp_name"
										bindValue="apptid" [clearable]="true" [multiple]="false" 
										formControlName="company" placeholder="Company*"
										(change)="getVesselListByCompany(i,true);getBranchListByCompany(i,true);"
										[appearance]="'outline'" [ngClass]="{'is-invalid':showError2(i,'company')}">
									</ng-select>
									<p *ngIf="showError2(i,'company')" class="text-danger">
										<span *ngIf="creds.get('company')?.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<ng-select appendTo="body" [items]="branchList[i]" bindLabel="name" bindValue="id"
										[clearable]="true" [multiple]="false" formControlName="branch"
										placeholder="Branch" [appearance]="'outline'"
										[ngClass]="{'is-invalid':showError2(i,'branch')}">
									</ng-select>
									<p *ngIf="showError2(i,'branch')" class="text-danger">
										<span *ngIf="creds.get('branch')?.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<ng-select appendTo="body" [items]="vesselList[i]" bindLabel="vessel" bindValue="id"
										[clearable]="true" [multiple]="false" formControlName="vessel"
										placeholder="Vessel" [appearance]="'outline'"
										[ngClass]="{'is-invalid':showError2(i,'vessel')}">
									</ng-select>
									<p *ngIf="showError2(i,'vessel')" class="text-danger">
										<span *ngIf="creds.get('vessel')?.errors?.required">
											Required
										</span>
									</p>
								</div>
							</div> -->
							<div class="row g-1 mb-2">
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'phone_no')}"
											formControlName="phone_no" placeholder="Phone No.">
										<label for="phone_no">Phone No.</label>
									</div>
									<p *ngIf="showError2(i,'phone_no')" class="text-danger">
										<span *ngIf="creds.get('phone_no')?.errors?.required">
											Required
										</span>
										<span *ngIf="creds.get('phone_no')?.errors?.pattern">
											Invalid
										</span>
									</p>
								</div>
								<!-- <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'crew_id')}"
											formControlName="crew_id" placeholder="Crew Id">
										<label for="crew_id">Crew Id</label>
									</div>
									<p *ngIf="showError2(i,'crew_id')" class="text-danger">
										<span *ngIf="creds.get('crew_id')?.errors?.required">
											Required
										</span>
									</p>
								</div> -->
								<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
									<mat-form-field appearance="outline">
										<mat-label>Date of Birth(MM/DD/YYYY)</mat-label>
										<input matInput [matDatepicker]="dob_picker_template" formControlName="dob"
											(change)="calculateAge(i)">
										<mat-datepicker-toggle matIconSuffix
											[for]="dob_picker_template"></mat-datepicker-toggle>
										<mat-datepicker #dob_picker_template
											(closed)="calculateAge(i)"></mat-datepicker>
									</mat-form-field>
									<p *ngIf="showError2(i,'dob')" class="text-danger">
										<span *ngIf="creds.get('dob')?.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'age')}"
											formControlName="age" placeholder="Age*">
										<label for="age">Age</label>
									</div>
									<p *ngIf="showError2(i,'age')" class="text-danger">
										<span *ngIf="creds.get('age')?.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
									<ng-select appendTo="body" [items]="trainerList" bindLabel="full_name"
										bindValue="apptid" [clearable]="true" [multiple]="false"
										formControlName="trainers_id" placeholder="Trainer*" [appearance]="'outline'"
										[ngClass]="{'is-invalid':showError2(i,'trainers_id')}">
									</ng-select>
									<p *ngIf="showError2(i,'trainers_id')" class="text-danger">
										<span *ngIf="creds.get('trainers_id')?.errors?.required">
											Required
										</span>
									</p>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
			<div class="row g-1 mb-2">
				<div class="col">
					@if(refNo){
					<button type="button" class="btn btn-sm btn-outline-info" (click)="gotoQueAns()">
						Answers
					</button>
					}
					<button type="submit" [disabled]="showLoader" class="btn btn-sm btn-outline-success ms-1">
						<span class="me-1">
							<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
							<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						</span>
						<span>Submit</span>
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/appointmentList']">Cancel</a>
					<button type="button" (click)="addAppointments();apptCountChanged();"
						class="btn btn-sm btn-outline-primary float-end">
						<span class="me-1">
							<fa-icon [icon]="['fas', 'plus']"></fa-icon>
						</span>
						<span>Add</span>
					</button>
				</div>
			</div>
		</form>
	</div>
</div>
<div *ngIf="UserModuleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>